import Query from '../../../components/Report';

const query = (current_url) =>
    new Query('search-urls-urls-detail-chart', {
        current_url,
    });

export default query;
